const informationCampaign = {
  legal_name: '',
  cnpj: '',
  total_invoices: 0,
  count_invoices: 0,
  count_assignors: 0,
  average_time: '',
  operation: {},
  errors: ['errors']
}

export default {
  list: [],
  listAvaliable: [],
  initInformationCampaign: { ...informationCampaign },
  informationCampaign: { ...informationCampaign }
}



// WEBPACK FOOTER //
// ./src/features/campaigns/store/state.js